module.exports = __webpack_public_path__ + "static/media/frame_04.9e2e96aa.png";